var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_834_90218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 0.0292969C5.79706 0.0292969 0.414062 5.4123 0.414062 12.0293C0.414062 18.6463 5.79706 24.0293 12.4141 24.0293C19.0311 24.0293 24.4141 18.6463 24.4141 12.0293C24.4141 5.4123 19.0311 0.0292969 12.4141 0.0292969ZM12.3231 15.4483C11.9361 15.8353 11.4271 16.0283 10.9161 16.0283C10.4051 16.0283 9.89106 15.8333 9.50006 15.4433L6.71806 12.7473L8.11106 11.3103L10.9041 14.0173L16.7131 8.3163L18.1171 9.7413L12.3231 15.4483Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_834_90218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.414062 0.0292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.6f523991984866a1ee46b47cd5d537c9.svg";
export { ForwardRef as ReactComponent };